export const LOADING_STORE_KEY = 'loading';
